let due_date_calculator = (function( $ ) {

    let _init = function() {
        const methodSelect = document.getElementById('calc_method');
        const dateGroup    = document.getElementById('group-date');
        const egaGroup     = document.getElementById('group-ega');
        const cycleGroup   = document.getElementById('group-cycle');

        const dateInput    = document.getElementById('input_date');
        const egaWeeks     = document.getElementById('ega_weeks');
        const egaDays      = document.getElementById('ega_days');

        const tabs         = document.querySelectorAll('.pc-tab');
        const tabContents  = document.querySelectorAll('.pc-tab-content');

        tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                tabs.forEach(t => t.classList.remove('active'));
                this.classList.add('active');

                tabContents.forEach(content => content.style.display = 'none');

                const targetId = 'content-' + this.dataset.tab;
                const targetContent = document.getElementById(targetId);
                if (targetContent) {
                    targetContent.style.display = 'block';
                }
            });
        });

        if ( !methodSelect || !dateGroup || !egaGroup || !cycleGroup ) {
            return;
        }

        function updateFormState() {
            const val = methodSelect.value;

            cycleGroup.style.display = 'block';

            if (val === 'ega') {
                dateGroup.style.display      = 'none';
                egaGroup.style.display       = 'flex';
                egaGroup.style.flexDirection = 'column';

                if (dateInput) {
                    dateInput.removeAttribute('required');
                }

                if (egaWeeks) {
                    egaWeeks.setAttribute('required', 'required');
                }

                if (egaDays) {
                    egaDays.setAttribute('required', 'required');
                }

            } else {
                dateGroup.style.display = 'block';
                egaGroup.style.display  = 'none';

                if (dateInput) {
                    dateInput.setAttribute('required', 'required');
                }

                if (egaWeeks) {
                    egaWeeks.removeAttribute('required');
                }

                if (egaDays) {
                    egaDays.removeAttribute('required');
                }
            }
        }

        const resultContainer = document.getElementById('pc-results-container');
        if ( resultContainer ) {
            resultContainer.scrollIntoView({ behavior: 'smooth' });
        }

        methodSelect.addEventListener('change', updateFormState);
        updateFormState();
    };

    $( document ).ready( _init );

    return {};

})( jQuery );

module.exports = due_date_calculator;